import Vue from "vue";

export const search = ({ dispatch }, params) => {
  dispatch("LOADING", false);
  Vue.http.get("api/v1/Search", params).then(function (response) {
    dispatch("SEARCH_RESULTS_LOADED", response.data);
  });
};

export const searchProducts = ({ dispatch }, searchString) => {
  dispatch("SEARCH_STRING_SET", searchString);
  dispatch("LOADING", false);
  Vue.http.get("api/v1/Search/Products/" + searchString).then(function (response) {
    dispatch("SEARCH_PRODUCTS_LOADED", response.data);
  });
};

export const isProductAvailable = ({ dispatch }, id) => {
  dispatch("LOADING", false);
  Vue.http.get("api/v1/Search/IsProductAvailable", {itemId: id}).then(function (response) {
    dispatch("SEARCH_VALIDATION_LOADED", response.data);
  });
};



// WEBPACK FOOTER //
// ./src/views/search/SearchActions.js